import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
// import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {


  keySize = 128 / 32;
  iterationCount = 1000;

  generateKey(salt: any, passPhrase: any) {
    var key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
      keySize: this.keySize,
      iterations: this.iterationCount
    });
    return key;
  }

  encrypt(plainText: any) {
    let genKey = localStorage.getItem('identificationNo');
    let iv = localStorage.getItem('iv');
    iv = iv != null ? iv : '';
    genKey = genKey != null ? genKey : '';

    var encrypted = CryptoJS.AES.encrypt(
      plainText,
      (genKey = JSON.parse(genKey)),
      { iv: CryptoJS.enc.Hex.parse(iv) }
    );
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }
  decrypt(cipherText1: any) {
    let genKey = localStorage.getItem('identificationNo');
    let iv = localStorage.getItem('iv');
    iv = iv != null ? iv : '';
    genKey = genKey != null ? genKey : '';
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipherText1)
    });
    var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      (genKey = JSON.parse(genKey)),
      { iv: CryptoJS.enc.Hex.parse(iv) }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
